<template>
  <div>
    <br />
    <v-row dense>
      <v-col sm="7">
        <v-select
          v-model="siteName"
          v-on:change="RefreshUnitAreas"
          :items="sortSite"
          label="Site"
          dense
          solo
          hide-details
          @input="changeSite()"
          >Select a Site</v-select
        >
      </v-col>
    </v-row>
    <v-row dense>
      <v-col sm="12">
        <v-treeview 
          dense
          v-if="info != null"
          :items="info.data.items"
          v-model="selectedItemComputed"
          selectable
          :open.sync="openedTree"
        >
          <template v-slot:label="{ item }">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{ item.name }}
                </span>
              </template>
              <span>{{ item.description }}</span>
            </v-tooltip>
          </template>
        </v-treeview>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import uiView from "@/_mixins/ui-view-mixin";
import axios from "axios";
import appConfig from "../app.config";
import settingsMixins from "../mixins/settings-mixin";
import appMixin from "../mixins/app-mixin";
export default {
  name: "SamplePage",
  mixins: [settingsMixins, uiView, appMixin],
  props: {
    selectedItem: { type: Array, default: [] },
    updateItem: { type: Boolean, default: false },
    selSiteName: {type:String, default: ""},
  },
  watch: {
    selectedItemInternal(val) {
      this.$emit("update:selectedItem", val);
    },
    userArea(val) {
      this.getPrefernceArea();
    },
    updateItem(val) {
    //  console.log("updated",, val);
this.siteName = this.selSiteName;

       this.RefreshUnitAreas();
    },
  },
  computed: {
    selectedItemComputed: {
      get() {
        return this.selectedItemInternal;
      },
      set(val) {
        this.selectedItemInternal = val;
      },
    },
  },
  data() {
    return {
      siteName: "",
      userArea: "",
      list: [],
      openedTree:[],
      selectedItemInternal: null,
      userSites: [], // data for the site dropdown list
      sortSite: [],
      info: null, // data for the treeview control
      items: [],
      userInfo: null,
      treeviewSelection: [],
    };
  },
  mounted() {  },

  created() {
    this.applicationSettings = appConfig;
    this.GetUserSites();
    if (this.limsds_userDetails.userEmail != null) {
      this.list = this.limsds_userPreference;
      this.siteName = this.list.site1;
      if (this.list.Areas != null) {
        this.userArea = this.list.Areas;
      }
      if (this.siteName != null) {
        this.RefreshUnitAreas();
        this.GetTreeViewSelection();
      }
    }
  },
  methods: {
    reloadPage(){
      this.applicationSettings = appConfig;
    this.GetUserSites();
    if (this.limsds_userDetails.userEmail != null) {
      this.list = this.limsds_userPreference;
      this.siteName = this.list.site1;
      if (this.list.Areas != null) {
        this.userArea = this.list.Areas;
      }
      if (this.siteName != null) {
        this.RefreshUnitAreas();
        this.GetTreeViewSelection();
      }
    }
    },
    getPrefernceArea() {
      let that = this;
      const XmlToJson =
        that.settings.WAXmlToJson +
        "userid=" +
        that.limsds_userDetails.userEmail +
        "&XmlString=" +
        this.userArea;
        
      axios.get(XmlToJson).then((response) => {
        that.selectedItemInternal = response.data[0].result.split(",");
        console.log("internal", that.selectedItemInternal);
      });
    },

    changeSite: function () {
      this.$emit("input", this.siteName);
    },
    // this is called when the site dropdown is changed
    RefreshUnitAreas() {
      const treeview_input = {
        site: this.siteName,
        userId: this.limsds_userDetails.userEmail,
        lims_internal: 0,
      };
      let self = this;
      //alert(this.siteName)
      const siteUnitAreaList = self.settings.WASiteUnitArea;
      axios
        .post(siteUnitAreaList, treeview_input)
        .then((response) => {
          this.info = response;
          this.openedTree = this.info.data.items? [this.info.data.items[0].name]: "";
          this.userArea =this.limsds_userPreference.Areas;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    SyncTreeviewSelectionToDB(unitAreaString) {
      try {
        // need to sync the treeview selection back to DB so that next time user comes in the site/unit/area
        // selection can be pulled from DB and populate the treeview control
      } catch (e) {
        console.error(e.error);
      }
    },

    GetTreeViewSelection() {
      try {
        // retrieve the user selected site/unit/area saved in the preference table
        // selection can be pulled from DB and populate the treeview control
        const treeview_input = {
          site: this.siteName,
          userId: this.limsds_userDetails.userEmail,
          lims_internal: 0,
        };
        let self = this;
        const siteUnitAreaList = self.settings.WASiteUnitArea;
        axios
          .post(siteUnitAreaList, treeview_input)
          .then((response) => {
            this.info = response;
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (e) {
        console.error(e.error);
      }
    },

    GetSampleArrivalList() {
      //construct the site/unit/area xml to get the list of sample arrivals
      // This is to reuse the existing method to retrieve the sample arrival list by passing unitArea as xml
      try {
        let list = [];
        let listSelected = [];
        let splitArray = [];

        let unitCount = this.info.data.items[0].children.length;

        for (var i = 0; i < unitCount; i++) {
          // this set up the array that stores unit name and count of area for each unit
          //[
          //  { unit: "BKT", count: 4}
          //  { unit: "BDEUP", count: 7}
          //]
          list.push({
            unit: this.info.data.items[0].children[i].name,
            count: this.info.data.items[0].children[i].children.length,
          });
        }

        for (var i = 0; i < unitCount; i++) {
          // loop through the unit name and count of area array,  find out if
          let unitName = list[i].unit;
          // check how many items in the selected items array belongs to this unit
          debugger;
          let selectedItemCount = this.treeviewSelection.length;
          let selectedUnitAreaCount = 0;
          let area = [];

          for (var j = 0; j < selectedItemCount; j++) {
            splitArray = this.treeviewSelection[j].split("_");
            if (splitArray[1] == unitName) {
              selectedUnitAreaCount++;
              area.push({
                area: splitArray[2],
              });
            }
          }
          listSelected.push({
            unit: unitName,
            areaList: area,
            availableAreaCount: list[i].count,
            areaCount: selectedUnitAreaCount,
          });
        }

        // loop through the listSelected array to generate the xml
        let doc = document.implementation.createDocument("", "", null);
        debugger;
        let rootElem = doc.createElement("root");
        rootElem.setAttribute("site", this.siteName);

        for (var i = 0; i < listSelected.length; i++) {
          let unitElem = doc.createElement("unit");
          unitElem.setAttribute("id", listSelected[i].unit);
          if (
            listSelected[i].areaCount > 0 &&
            listSelected[i].areaCount == listSelected[i].availableAreaCount
          ) {
            //if there are selected area and all area are selected, then just include the unit tag, no need
            //to list the individual areas, not need to add area lsit here. do nothing
          } else if (
            listSelected[i].areaCount > 0 &&
            listSelected[i].areaCount != listSelected[i].availableAreaCount
          ) {
            //not all area under a unit is selected, need to list all areas selected
            for (var j = 0; j < listSelected[i].areaList.length; j++) {
              let areaElem = doc.createElement("area");
              areaElem.setAttribute("id", listSelected[i].areaList[j].area);
              unitElem.appendChild(areaElem);
            }
          }

          if (listSelected[i].areaCount > 0) {
            rootElem.appendChild(unitElem);
          }
        }
        doc.appendChild(rootElem);
        debugger;
        let serializer = new XMLSerializer();
        let xmlStr = serializer.serializeToString(doc);

        const sampleArrivalInput = {
          site: this.siteName,
          userId: this.limsds_userDetails.userEmail,
          lims_internal: 0,
        };
        //alert(this.siteName)
        let self = this;
        const siteUnitAreaList = self.settings.WASiteUnitArea;
        axios
          .post(
            siteUnitAreaList,
            //this.applicationSettings.settings.baseUrl + "/SiteUnitArea",
            treeview_input
          )
          .then((response) => {
            this.info = response;
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (e) {
        console.error(e.error);
      }
    },

    // Looks like the API is needed
    GetUserSites() {
      try {
        var self = this;
        const siteList = self.settings.WASites;
        axios
          .get(siteList)
          .then((response) => {
            let count = response.data.value.length;

            for (var i = 0; i < count; i++) {
              self.userSites.push(response.data.value[i].Code);
            }
            self.sortSite=self.userSites.sort();
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (e) {
        console.error(e.error);
      }
    },
  },
};
</script>

<style lang="scss">
.v-treeview--dense .v-treeview-node__root {
  min-height: 10px !important;
}
.v-treeview-node__label {
    flex: 1;
    font-size: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.v-input {
    align-items: flex-start;
    display: flex;
    flex: 1 1 auto;
    font-size: 12px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
}
.v-text-field--outlined.v-input--is-focused fieldset, .v-text-field--outlined.v-input--has-state fieldset {
    border: 1px solid currentColor;
}
.v-text-field--outlined fieldset {
    border-collapse: collapse;
    border-color: currentColor;
    border-style: solid;
    border-width: 1px;
    bottom: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0px;
    transition-duration: 0.15s;
    transition-property: color;
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);
}
</style>
